import img_shapu_front from "../assets/tangible/shapu-front.png";
import img_shapu_right from "../assets/tangible/shapu-right.png";
import img_shapu_left from "../assets/tangible/shapu-left.png";
import img_mountain from "../assets/tangible/mountain.png";
import img_moon from "../assets/tangible/moon.png";
import img_sun from "../assets/tangible/sun.png";
import img_ice_cream from "../assets/tangible/ice-cream.png";
import img_house from "../assets/tangible/house.png";
import audio_hi from "../assets/tangible/hi.mp3";
import audio_house from "../assets/tangible/house.mp3";
import audio_do_you_know from "../assets/tangible/do_you_know.mp3";
import audio_ice_cream from "../assets/tangible/ice-cream.mp3";
import audio_learn from "../assets/tangible/learn.mp3";
import audio_mountains from "../assets/tangible/mountains.mp3";
import audio_sun_moon from "../assets/tangible/sun_moon.mp3";
import audio_yourturn from "../assets/tangible/yourturn.mp3";
export const stageData = {
  preload: [
    img_shapu_front,
    img_shapu_right,
    img_shapu_left,
    img_mountain,
    img_moon,
    img_sun,
    img_ice_cream,
    img_house
  ],
  background: {
    objects: [
      {
        type: "rectangle",
        fill: {
          type: "gradient",
          stop: [
            { position: 0.4, color: "#D9FFC7" },
            { position: 1, color: "#000000" }
          ],
          circles: [{ x: 0, y: 0, radius: 50 }, { x: 0, y: 0, radius: 800 }]
        },
        stroke: null,
        x: 400,
        y: 250,
        anchorX: 400,
        anchorY: 250,
        width: 800,
        height: 500,
        angle: null
      }
    ]
  },
  foreground: {
    scene: {
      "1": {
        meta: {
          scene: 1,
          duration: 2200,
          next: 2
        },
        objects: [
          {
            type: "image",
            url: img_shapu_front,
            x: 400,
            y: 380,
            anchorX: 63,
            anchorY: 136
          },
          {
            type: "text",
            text: "Hi, my name is shapu",
            x: 400,
            y: 200,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_hi }]
      },
      "2": {
        meta: {
          scene: 2,
          duration: 2000,
          next: 3
        },
        objects: [
          {
            type: "image",
            url: img_shapu_front,
            x: 400,
            y: 380,
            anchorX: 63,
            anchorY: 136
          },
          {
            type: "text",
            text: "let's learn something about shapes",
            x: 400,
            y: 200,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_learn }]
      },
      "3": {
        meta: {
          scene: 3,
          duration: 5000,
          next: 4
        },
        objects: [
          {
            type: "image",
            url: img_shapu_front,
            x: 700,
            y: 380,
            anchorX: 63,
            anchorY: 87
          },
          {
            type: "rectangle",
            fill: {
              type: "solid",
              color: "rgba(256,125,125,0.85)"
            },
            x: 700,
            y: 200,
            anchorX: 100,
            anchorY: 80,
            width: 200,
            height: 160,
            angle: 0,
            tween: {
              "0": {
                props: {
                  from: { x: 700, y: 200, angle: 0 },
                  to: { x: 650, y: 300, angle: 30 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "rectangle",
            fill: {
              type: "solid",
              color: "rgba(256,125,125,0.85)"
            },
            x: 150,
            y: 200,
            anchorX: 50,
            anchorY: 50,
            width: 100,
            height: 100,
            angle: 10,
            tween: {
              "0": {
                props: {
                  from: { x: 150, y: 200, angle: 10 },
                  to: { x: 200, y: 100, angle: 30 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "rectangle",
            fill: {
              type: "solid",
              color: "rgba(256,125,125,0.85)"
            },
            x: 100,
            y: 100,
            anchorX: 50,
            anchorY: 50,
            width: 100,
            height: 100,
            angle: 30,
            tween: {
              "0": {
                props: {
                  from: { x: 100, y: 100, angle: 30 },
                  to: { x: 150, y: 150, angle: 60 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "ellipse",
            fill: {
              type: "solid",
              color: "rgba(135,190,249,0.85)"
            },
            x: 100,
            y: 400,
            anchorX: 100,
            anchorY: 100,
            radiusX: 100,
            radiusY: 100,
            tween: {
              "0": {
                props: {
                  from: { x: 100, y: 400 },
                  to: { x: 300, y: 300 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "text",
            text: "Do you know, that everything we see around us,",
            x: 400,
            y: 456,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          },
          {
            type: "text",
            text: "is made of simple shapes",
            x: 400,
            y: 480,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_do_you_know }]
      },
      "4": {
        meta: {
          scene: 4,
          duration: 3600,
          next: 5
        },
        objects: [
          {
            type: "image",
            url: img_mountain,
            x: 400,
            y: 250,
            anchorX: 211,
            anchorY: 135
          },
          {
            type: "image",
            url: img_shapu_left,
            x: 100,
            y: 380,
            anchorX: 63,
            anchorY: 87
          },
          {
            type: "text",
            text: "Like mountains, look like triangle",
            x: 400,
            y: 480,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_mountains }]
      },
      "5": {
        meta: {
          scene: 5,
          duration: 7400,
          next: 6
        },
        objects: [
          {
            type: "image",
            url: img_sun,
            x: 200,
            y: 125,
            anchorX: 250,
            anchorY: 251,
            angle: 0,
            tween: {
              "0": {
                props: {
                  from: { angle: 0 },
                  to: { angle: 180 }
                },
                duration: 7400,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "image",
            url: img_moon,
            x: 600,
            y: 125,
            anchorX: 147,
            anchorY: 147
          },
          {
            type: "image",
            url: img_shapu_left,
            x: 100,
            y: 380,
            anchorX: 63,
            anchorY: 87
          },
          {
            type: "text",
            text: "Sun and moon, they are circles.",
            x: 400,
            y: 456,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          },
          {
            type: "text",
            text: "Even our planet earth is a circle",
            x: 400,
            y: 480,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_sun_moon }]
      },
      "6": {
        meta: {
          scene: 6,
          duration: 8000,
          next: 7
        },
        objects: [
          {
            type: "image",
            url: img_ice_cream,
            x: 400,
            y: 250,
            anchorX: 90,
            anchorY: 143
          },
          {
            type: "image",
            url: img_shapu_right,
            x: 700,
            y: 380,
            anchorX: 63,
            anchorY: 87
          },
          {
            type: "text",
            text: "Do you love Ice-cream,",
            x: 400,
            y: 432,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          },
          {
            type: "text",
            text: "ice-cream is my favourite.",
            x: 400,
            y: 456,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          },
          {
            type: "text",
            text: "If you see, the cone of an ice-cream looks like a triangle",
            x: 400,
            y: 480,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_ice_cream }]
      },
      "7": {
        meta: {
          scene: 7,
          duration: 5400,
          next: 8
        },
        objects: [
          {
            type: "image",
            url: img_house,
            x: 400,
            y: 250,
            anchorX: 181,
            anchorY: 151
          },
          {
            type: "image",
            url: img_shapu_right,
            x: 700,
            y: 380,
            anchorX: 63,
            anchorY: 87
          },
          {
            type: "text",
            text:
              "Let's take this small house. It's made of a square and a triangle",
            x: 400,
            y: 480,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_house }]
      },
      "8": {
        meta: {
          scene: 8,
          duration: 4700,
          next: null
        },
        objects: [
          {
            type: "rectangle",
            fill: {
              type: "solid",
              color: "rgba(256,125,125,0.85)"
            },
            x: 200,
            y: 200,
            anchorX: 100,
            anchorY: 80,
            width: 200,
            height: 160,
            angle: 0,
            tween: {
              "0": {
                props: {
                  from: { x: 200, y: 200, angle: 0 },
                  to: { x: 300, y: 300, angle: 30 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "rectangle",
            fill: {
              type: "solid",
              color: "rgba(256,125,125,0.85)"
            },
            x: 150,
            y: 200,
            anchorX: 50,
            anchorY: 50,
            width: 100,
            height: 100,
            angle: 10,
            tween: {
              "0": {
                props: {
                  from: { x: 150, y: 200, angle: 10 },
                  to: { x: 200, y: 100, angle: 30 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "rectangle",
            fill: {
              type: "solid",
              color: "rgba(256,125,125,0.85)"
            },
            x: 100,
            y: 100,
            anchorX: 50,
            anchorY: 50,
            width: 100,
            height: 100,
            angle: 10,
            tween: {
              "0": {
                props: {
                  from: { x: 100, y: 100, angle: 10 },
                  to: { x: 150, y: 150, angle: 60 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "ellipse",
            fill: {
              type: "solid",
              color: "rgba(135,190,249,0.85)"
            },
            x: 100,
            y: 400,
            anchorX: 100,
            anchorY: 100,
            radiusX: 100,
            radiusY: 100,
            tween: {
              "0": {
                props: {
                  from: { x: 100, y: 400 },
                  to: { x: 300, y: 300 }
                },
                duration: 5000,
                easeFunc: "linear"
              }
            }
          },
          {
            type: "image",
            url: img_shapu_right,
            x: 700,
            y: 380,
            anchorX: 63,
            anchorY: 87
          },
          {
            type: "text",
            text: "Okaay, it's your turn now,",
            x: 400,
            y: 456,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          },
          {
            type: "text",
            text: "create something with the shapes",
            x: 400,
            y: 480,
            style: "normal",
            variant: "normal",
            weight: "normal",
            stretch: "",
            size: 24,
            lineHeight: "1",
            family: "indie-flower",
            fill: {
              color: "#000000"
            },
            stroke: null,
            angle: 0
          }
        ],
        audio: [{ url: audio_yourturn }]
      }
    }
  },
  start: "1",
  end: "8",
  width: 800,
  height: 500
};



// WEBPACK FOOTER //
// ./src/data/data.js